// Copy for the courier-delivery status block on the receipt page. Customers
// should never see the courier partner's name, so these labels stay generic
// even though the underlying status values come from that partner's API.
const STATUS_LABELS = {
  pending: 'Delivery booked',
  pickup: 'Courier on the way to the kitchen',
  pickup_complete: 'Your order is on its way',
  dropoff: 'Courier is nearby',
  delivered: 'Delivered',
  canceled: 'Delivery could not be completed, the store will be in touch',
  returned: 'Delivery could not be completed, the store will be in touch',
  failed: ''
}

const TERMINAL_STATUSES = ['delivered', 'canceled', 'returned', 'failed']
const COURIER_NAME_STATUSES = ['pickup', 'pickup_complete', 'dropoff']

export const deliveryStatusLabel = (status) => STATUS_LABELS[status] || ''

export const isTerminalDeliveryStatus = (status) => TERMINAL_STATUSES.includes(status)

export const showsCourierName = (status) => COURIER_NAME_STATUSES.includes(status)

export const courierFirstName = (courierName) => (courierName ? courierName.trim().split(' ')[0] : '')

// Whether the receipt page should keep polling for updates on this delivery.
export const shouldPollDelivery = (delivery) => Boolean(delivery?.is_active) && delivery?.status !== 'delivered'

// The four stops shown in the delivery step tracker.
export const DELIVERY_STEP_LABELS = ['Booked', 'Courier on the way', 'Picked up', 'Delivered']

// Which stop (1-4) in the tracker a status belongs to. pickup_complete and dropoff both land on
// "Picked up" - dropoff gets an extra sub-label in the UI to show it's the later of the two.
// Returns 0 for statuses that don't have a place on the tracker (canceled, returned, failed, unknown).
const STEP_BY_STATUS = {
  pending: 1,
  pickup: 2,
  pickup_complete: 3,
  dropoff: 3,
  delivered: 4
}

export const deliveryStep = (status) => STEP_BY_STATUS[status] || 0

// Headline copy for the receipt page's delivery card, written in the customer's own words.
const HEADLINES = {
  pending: 'Your delivery is booked',
  pickup: 'A courier is on the way to collect your order',
  pickup_complete: 'Your order is on its way',
  dropoff: 'Your courier is nearby',
  delivered: 'Delivered'
}

export const deliveryHeadline = (status) => HEADLINES[status] || ''
